import { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { DEFAULT_EASE } from '../../../../rise/constants/transition';

interface VariantWrapperProps {
    children: ReactNode,
}

function VariantWrapper(props: VariantWrapperProps) {
    return (
        <motion.div
            style={{
                position: 'relative',
                width: '100vw',
                height: '100vh',
                color: 'white',
            }}
            transition={{
                duration: 1,
                ease: DEFAULT_EASE,
            }}
            exit={{
                y: `-100vh`,
                transition: {
                    ease: DEFAULT_EASE,
                    duration: 1,
                },
            }}
        >
            {props.children}
        </motion.div>
    );
}

export default VariantWrapper;
